<template>
  <div v-if="screenData" class="view tv dark">
    <Screen :data="tv1Screen2">
      <template #header>
        <HeaderBlock>
          <TransportList :current-filter="screenData.currentTransportFilter" />
          <Baseline :data="header.baseline" />
        </HeaderBlock>
      </template>
      <TableBlock :data="tv1Screen2.data" :index="index" />
    </Screen>
    <Screen :data="tv2Screen4">
      <TableBlock :data="tv2Screen4.data" />
    </Screen>
    <Screen :data="tv3Screen4">
      <TableBlock :data="tv3Screen4.data" :index="index" />
    </Screen>
  </div>
</template>

<script>
import Tv from './TvMixin';
export default {
  mixins: [Tv],

  data() {
    return {
      state: '',
      lastState: '',
      distribution: '',
      index: -1,
      screenData: null,
    };
  },

  computed: {
    header() {
      const { averageTime } = this.screenData;
      return {
        baseline: {
          value: averageTime,
          sub: ' min',
          caption: `${this.$t('averageTimeByCurrentSite')} :`,
        },
      };
    },

    tv1Screen2() {
      const { averageTime, sites } = this.screenData;
      return {
        heading: {
          caption: this.$t('averageAccessTime'),
          icon: 'clock',
          baseline: {
            value: averageTime,
            sub: ' min',
            caption: `${this.$t('CurrentSiteName')} :`,
          },
        },
        data: {
          entries: this.computeAverageTime(sites, averageTime),
        },
      };
    },

    tv2Screen4() {
      const { collaboratorsByRegion, sites } = this.screenData;
      const subHeaderCaption = this.$t('CurrentSiteName');
      const subHeader = {
        type: 'sub-header',
        caption: subHeaderCaption,
      };
      const superHeader = [subHeader];

      const specifications = [subHeader];
      collaboratorsByRegion.slice(0, 4).forEach(region => {
        superHeader.push({
          caption: region.caption,
          value: region.percentage,
          sub: '%',
        });
        specifications.push({
          value: region.averageTime,
          sub: ' min',
        });
      });
      const entries = sites.map(site => {
        const result = [subHeader];
        site.details.collaboratorsByRegion
          .slice(0, 4)
          .forEach((item, idx) => result.push(this.computeTrend(item.averageTime - collaboratorsByRegion[idx].averageTime)));
        return result;
      });

      const data = {
        superHeader,
        specifications,
        entries,
      };
      return {
        data,
      };
    },

    tv3Screen4() {
      const { collaboratorsByRegion, sites } = this.screenData;
      const subHeaderCaption = this.$t('CurrentSiteName');
      const subHeader = {
        type: 'sub-header',
        caption: subHeaderCaption,
      };
      const superHeader = [subHeader];

      const specifications = [subHeader];
      collaboratorsByRegion.slice(4, 8).forEach(region => {
        superHeader.push({
          caption: region.caption,
          value: region.percentage,
          sub: '%',
        });
        specifications.push({
          value: region.averageTime,
          sub: ' min',
        });
      });
      const entries = sites.map(site => {
        const result = [subHeader];
        site.details.collaboratorsByRegion
          .slice(4, 8)
          .forEach((item, idx) => result.push(this.computeTrend(item.averageTime - collaboratorsByRegion[idx + 4].averageTime)));
        return result;
      });

      const data = {
        superHeader,
        specifications,
        entries,
      };
      return {
        data,
      };
    },
  },

  mounted() {
    const id = this.$route.params.studyId;
    this.$store.dispatch('getStudyResult', { id }).then(() => {
      this.screenData = this.$store.getters.screen();
    });
  },
};
</script>
